export class ConstantTypeKey {
    public static DayList = 'DayList';
    public static UserType = 'UserType';
    public static IndustryVertical = 'IndustryVertical';
    public static OfferType = 'OfferType';
    public static AgencyType = 'AgencyType';
}
